module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-bouquet-3-a233745fb0791d25cefd24e3b00ed05d.jpg";